module.exports = __webpack_public_path__ + "static/media/study 201111.31d4af42.png";